import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { UpdateParticipantQR } from '../mutations/updateParticipantQR.mutation';
import type { UpdateParticipantQrMutation, UpdateParticipantQrMutationVariables } from '../types';

export const useUpdateParticipantQRMutation = (
  options?: MutationOptions<UpdateParticipantQrMutation, UpdateParticipantQrMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(UpdateParticipantQR), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
